import React, { useState, useEffect } from "react";

function IntroSection() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const isAdmin = sessionStorage.getItem("isAdmin") === "true";
  const [intro, setIntro] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    fetch(`${baseUrl}/api/introduction`)
      .then(res => res.json())
      .then(data => setIntro(data.content || "소개글을 작성해주세요."))
      .catch(() => setIntro("소개글을 불러오지 못했습니다."));
  }, []);

  const handleSave = () => {
    fetch(`${baseUrl}/api/introduction`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ content: intro })
    })
      .then(() => setIsEditing(false))
      .catch(err => alert("저장 실패: " + err));
  };

  return (
    <section style={{ padding: "20px 20px 20px", background: "#fff" }}>
      <p
        style={{
          fontSize: "14px",
          color: "#98bcc9",
          marginBottom: "10px",
          textAlign: "center"
        }}
      >
        아이엠플러스교육심리센터
      </p>

      <div style={{ maxWidth: 1000, margin: "0 auto", position: "relative", textAlign: "center" }}>
        {isAdmin && (
          <button
            onClick={() => {
              if (isEditing) handleSave();
              else setIsEditing(true);
            }}
            style={{
              position: "absolute",
              top: "-45px",
              right: 0,
              fontSize: "16px",
              padding: "8px 18px",
              background: "#98bcc9",
              color: "#fff",
              border: "none",
              borderRadius: "0px",
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
            }}
          >
            {isEditing ? "저장" : "수정"}
          </button>
        )}

        {isAdmin && isEditing ? (
          <textarea
            value={intro}
            onChange={e => setIntro(e.target.value)}
            rows={12}
            style={{
              width: "100%",
              marginBottom: 12,
              padding: "12px",
              border: "1px solid #ccc",       // ← 테두리 추가
              borderRadius: "8px",            // ← 약간의 둥근 모서리
              fontSize: "16px",
              lineHeight: "1.6",
              resize: "vertical",             // ← 사용자 크기 조절 가능
            }}
          />
        ) : (
          <pre
            style={{
              whiteSpace: "pre-wrap",
              lineHeight: 1.6,
              fontSize: "16px",
              color: "#333",
              fontFamily: "inherit"
            }}
          >
            {intro}
          </pre>
        )}
      </div>

      <div
        style={{
          marginTop: "16px",
          fontSize: "15px",
          display: "flex",
          justifyContent: "center",
          gap: "20px"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img src="/images/cellphone-icon.png" alt="전화 아이콘" width={20} height={20} />
          <span>031-928-7329</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img src="/images/smartphone-icon.png" alt="핸드폰 아이콘" width={20} height={20} />
          <span>010-3251-7329</span>
        </div>
      </div>
    </section>
  );
}

export default IntroSection;
